import {
    IFareAssistant
} from "./i-fare-assistant";

export const DEFAULT_CONFIG_OPTIMISATION_PARAMS: IFareAssistant[] = [
    {
        code: "RQA_NEGPUB",
        isDefinitive: true,
        labelArray: [
            {
                languageCode: "fr",
                value: "De NEG vers PUB"
            }
        ],
        descriptionArray: [
            {
                languageCode: "fr",
                value: "L'optimisation requiert un type de tarif non désiré"
            }
        ]
    },
    {
        code: "RQA_BKUCFM",
        isDefinitive: false,
        labelArray: [
            {
                languageCode: "fr",
                value: "Dossier non confirmé"
            }
        ],
        descriptionArray: [
            {
                languageCode: "fr",
                value: "Le dossier n'a pas encore été confirmé"
            }
        ]
    },
    {
        code: "RQA_UNWSPL",
        isDefinitive: true,
        labelArray: [
            {
                languageCode: "fr",
                value: "Split"
            }
        ],
        descriptionArray: [
            {
                languageCode: "fr",
                value: "L'optimisation requiert une séparation du dossier non désirée"
            }
        ]
    },
    {
        code: "RQA_LDTP",
        isDefinitive: true,
        labelArray: [
            {
                languageCode: "fr",
                value: "Date d'émission"
            }
        ],
        descriptionArray: [
            {
                languageCode: "fr",
                value: "La nouvelle date d'émission est trop restrictive"
            }
        ]
    },
    {
        code: "RQA_XBCOND",
        isDefinitive: true,
        labelArray: [
            {
                languageCode: "fr",
                value: "Conditions d'annulation"
            }
        ],
        descriptionArray: [
            {
                languageCode: "fr",
                value: "Les nouvelles conditions d'annulation sont trop restrictives"
            }
        ]
    },
    {
        code: "RQA_ROTHER",
        isDefinitive: false,
        labelArray: [
            {
                languageCode: "fr",
                value: "Autre raison"
            }
        ],
        descriptionArray: [
            {
                languageCode: "fr",
                value: "Autre raison - précision requise <5 à 140 caractères"
            }
        ]
    }
];
